import React, { useState, useEffect } from 'react';
import './sidebar.css';
import Logo from '../../assets/AL.svg';

const Sidebar = () => {
	const [toggle, showMenu] = useState(false);
	const [activeIcon, setActiveIcon] = useState('');

	// Function to handle icon click
	const handleIconClick = (iconName) => {
		setActiveIcon(iconName); // Set the clicked icon as active
		window.location.hash = `#${iconName}`; // Change the URL hash
	};

	// Check the current URL hash when the component mounts or when the URL changes
	useEffect(() => {
		const currentHash = window.location.hash.substring(1); // Remove the '#' from the hash
		if (currentHash) {
			setActiveIcon(currentHash); // Set the active icon based on the current hash
		}
	}, []); // This effect runs only once when the component mounts

	// Watch for changes in the hash during navigation
	useEffect(() => {
		const handleHashChange = () => {
			const currentHash = window.location.hash.substring(1);
			if (currentHash) {
				setActiveIcon(currentHash);
			}
		};

		window.addEventListener('hashchange', handleHashChange);

		// Clean up the event listener
		return () => {
			window.removeEventListener('hashchange', handleHashChange);
		};
	}, []);

	return (
		<>
			<aside className={toggle ? 'aside show-menu' : 'aside'}>
				<a
					href='#home'
					className='nav__logo'
				>
					<img
						src={Logo}
						alt=''
					/>
				</a>

				<nav className='nav'>
					<div className='nav__menu'>
						<ul className='nav__list'>
							<li className='nav__item'>
								<a
									href='#home'
									className='nav__link'
									onClick={() => handleIconClick('home')}
								>
									<i
										className={`icon-home ${
											activeIcon === 'home' ? 'active' : ''
										}`}
									></i>
								</a>
							</li>

							<li className='nav__item'>
								<a
									href='#services'
									className='nav__link'
									onClick={() => handleIconClick('services')}
								>
									<i
										className={`icon-briefcase ${
											activeIcon === 'services' ? 'active' : ''
										}`}
									></i>
								</a>
							</li>

							{/* <li className='nav__item'>
								<a
									href='#resume'
									className='nav__link'
								>
									<i className='icon-graduation'></i>
								</a>
							</li> */}

							<li className='nav__item'>
								<a
									href='#work'
									className='nav__link'
									onClick={() => handleIconClick('work')}
								>
									<i
										className={`icon-layers ${
											activeIcon === 'work' ? 'active' : ''
										}`}
									></i>
								</a>
							</li>

							<li className='nav__item'>
								<a
									href='#about'
									className='nav__link'
									onClick={() => handleIconClick('about')}
								>
									<i
										className={`icon-user-following ${
											activeIcon === 'about' ? 'active' : ''
										}`}
									></i>
								</a>
							</li>

							{/* <li className='nav__item'>
								<a
									href='#blog'
									className='nav__link'
								>
									<i className='icon-note'></i>
								</a>
							</li> */}

							<li className='nav__item'>
								<a
									href='#contact'
									className='nav__link'
									onClick={() => handleIconClick('contact')}
								>
									<i
										className={`icon-bubble ${
											activeIcon === 'contact' ? 'active' : ''
										}`}
									></i>
								</a>
							</li>
						</ul>
					</div>
				</nav>

				<div className='nav__footer'>
					<span className='copyright'>&copy; 2024 - 2025.</span>
				</div>
			</aside>

			<div
				className={toggle ? 'nav__toggle nav__toggle-open' : 'nav__toggle'}
				onClick={() => showMenu(!toggle)}
			>
				<i className='icon-menu'></i>
			</div>
		</>
	);
};

export default Sidebar;
